
import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { BELOWMONITOR } from 'src/app/app.models';
import { CluPuSnackbarService } from '../../@services/clupu-snackbar.service';
import { ConnectorWCashDeskLoyaltyLandingService } from './connector-m-loyalty-landing.service';
import { CluWCashDeskLoyaltLandingClientInscriptionResult, CluWCashDeskMLoyaltyLandingClientItem } from './m-loyalty-landing.model';
import { MdLoyaltyInscriptionResComponent } from './md-loyalty-inscription-res/md-loyalty-inscription-res.component';
import { orderBy } from '@progress/kendo-data-query';
import { availableCountries } from 'src/app/utils/clu-zresources/clu-countries';

@Component({
  selector: 'm-loyalty-landing',
  templateUrl: './m-loyalty-landing.component.html',
  styleUrls: ['./m-loyalty-landing.component.scss'],
})
export class PublicWCashdeskMLoyaltyLandingComponent implements OnDestroy {
    private LAYOUT_BELOWMONITOR : boolean;
    private layoutChangesSubscription = Subscription.EMPTY;
    showProgressBar : boolean;
    lcParams : CluWCashDeskMLoyaltyLandingClientItem = new CluWCashDeskMLoyaltyLandingClientItem();
    searchInput : string; countries : any = availableCountries; filteredCountries: any[];
    codeInput : string;
    dobInputs : { DAY? : number, MONTH? : number, YEAR? : number } = { }; dobDays : number[] = []; dobYears : number[] = [];
    disableForm : boolean;
    inscriptionResult : CluWCashDeskLoyaltLandingClientInscriptionResult;
    constructor(private connector : ConnectorWCashDeskLoyaltyLandingService, private _snackbarService : CluPuSnackbarService, private _matDialog : MatDialog, private breakpointObserver: BreakpointObserver){
        this.countries = orderBy(this.countries, [{ field: "LIB", dir: "asc" }]);
        this.layoutChangesSubscription = this.breakpointObserver.observe([BELOWMONITOR]).subscribe((state) => { this.LAYOUT_BELOWMONITOR = state.breakpoints[BELOWMONITOR] });
        this.filteredCountries = this.countries.slice();
        for(let k = 1; k <= 31; k++) { this.dobDays.push(k); }
        for(let k = 1900; k <= new Date().getFullYear() - 1; k++) { this.dobYears.push(k); } this.dobYears = this.dobYears.reverse();
    }

    ngOnDestroy(): void {
      this.layoutChangesSubscription.unsubscribe();
    }

    doSaveWLoyaltyCardClientItemAction_PUPCashDeskLoyalty(){
        if(!this.codeInput || this.codeInput.length != 6) return;
        let _matchPAYS = this.countries.find((m : any) => m.CODE == this.lcParams.LC_PAYS);
        this.lcParams.LC_PAYS_LIB = _matchPAYS?.LIB;
        this.lcParams.LC_PAYS_INDICATIF = _matchPAYS?.INDICATIF;
        if(this.lcParams.LC_PAYS_LIB && this.lcParams.LC_PAYS_LIB.length > 69) this.lcParams.LC_PAYS_LIB = this.lcParams.LC_PAYS_LIB.substring(0, 68);
        if(this.lcParams.LC_PAYS_INDICATIF && this.lcParams.LC_PAYS_INDICATIF.length > 40) this.lcParams.LC_PAYS_INDICATIF = this.lcParams.LC_PAYS_INDICATIF.substring(0, 39);
        this.lcParams.LC_CODE_INSCRIPTION = this.codeInput;
        this.showProgressBar = true;
        this.connector.doSaveWLoyaltyCardClientItemAction_PUPCashDeskLoyalty(this.lcParams).subscribe({
            next : (res : any) => {
                console.log(res);
                this.inscriptionResult = res;
                this._snackbarService.displayMessage("SUCCESS", "Votre enregistrement a correctement été pris en compte!");
                this.doOpenMdLoyaltyInscriptionResModalAction_PUPCashDeskLoyalty(res);
                this.showProgressBar = false;
            }, 
            error : (err : any) => {
                console.error(err);
                if(err.error != undefined && err.error.Message != undefined){ this._snackbarService.displayMessage("ERROR", err.error.Message); }
                else { this._snackbarService.displayMessage("ERROR", "Une erreur est survenue lors de l'enregistrement.."); }
                this.showProgressBar = false; 
            }
        })
    }
    
    private doOpenMdLoyaltyInscriptionResModalAction_PUPCashDeskLoyalty( _inscriptionResult : CluWCashDeskLoyaltLandingClientInscriptionResult){
        let CC_WIDTH = this.LAYOUT_BELOWMONITOR ? '100%' : '600px';
        let CC_HEIGHT = this.LAYOUT_BELOWMONITOR ? '100%' : '80vh';
        this._matDialog.open(MdLoyaltyInscriptionResComponent, {autoFocus: false, disableClose: true, width: '100%', maxWidth: CC_WIDTH, minHeight: CC_HEIGHT, maxHeight: CC_HEIGHT, height : '100%', data : { res : _inscriptionResult } })
            .afterClosed()
            .subscribe((res) => { this.disableForm = true; });
    }

    // #region  Utils
    filterCountries() {
        // Filtrer les pays basés sur le texte de recherche
        this.filteredCountries = this.countries.filter((country : any) => country.LIB.toLowerCase().includes(this.searchInput.toLowerCase()));
    }

    validateInput(event: KeyboardEvent) {
        const pattern = /[0-9]/; // Seulement des chiffres
        const inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
          event.preventDefault();
        }
    }

    dobChangeEvent(){
        if(this.dobInputs.YEAR && this.dobInputs.MONTH && this.dobInputs.DAY) { 
            let daysInMonth = moment(this.dobInputs.YEAR.toString() + "-" + (this.dobInputs.MONTH.toString().length == 1 ? "0" + this.dobInputs.MONTH.toString() : this.dobInputs.MONTH.toString()), "YYYY-MM").daysInMonth();
            if(this.dobInputs.DAY > daysInMonth) { this.dobInputs.DAY = daysInMonth; }
            this.lcParams.LC_DATENAISSANCE = new Date(this.dobInputs.YEAR!, this.dobInputs.MONTH! - 1, this.dobInputs.DAY!);
        }
    }
    // #endregion
}
